import { object, ref, string } from "yup";

export const getValidation = (initialValues?: any) => {
  const validationSchema = object({
    firstName: string().required(),
    lastName: string().required(),
    email: string()
      .email()
      .trim()
      .required()
      .default(""),
    password: string()
      .when({ is: "", then: string(), otherwise: string().min(8) })
      .default(""),
    confirmPassword: string()
      .oneOf([ref("password")], "Password doesn't match Confirm Password.")
      .default(""),
    pin: string().default("")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({
      ...initialValues,
      pin: "",
      image: initialValues.image?._id
    })
  };
};
